import React, { lazy } from 'react';

const TaxSchemeListing = lazy(() =>
  import(
    'containers/SystemAdminModule/TaxSchemeModule/TaxSchemeListing'
  ).then(module => ({
    default: module.TaxSchemeListing,
  })),
);

const TaxSchemeDetail = lazy(() =>
  import(
    'containers/SystemAdminModule/TaxSchemeModule/TaxSchemeDetail'
  ).then(module => ({
    default: module.TaxSchemeDetail,
  })),
);

const TaxSchemeForm = lazy(() =>
  import(
    'containers/SystemAdminModule/TaxSchemeModule/TaxSchemeForm'
  ).then(module => ({
    default: module.TaxSchemeForm,
  })),
);

const taxSchemeRoutes = [
  {
    props: { exact: true, path: '/common-settings/tax-scheme/' },
    component: <TaxSchemeListing software="Contract" />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/tax-scheme/:taxSchemeID/detail',
    },
    component: <TaxSchemeDetail software="Contract" />,
  },
  {
    props: { exact: true, path: '/common-settings/tax-scheme/add' },
    component: <TaxSchemeForm software="Contract" mode="add" />,
  },
  {
    props: {
      exact: true,
      path: '/common-settings/tax-scheme/:taxSchemeID/edit',
    },
    component: <TaxSchemeForm software="Contract" mode="edit" />,
  },
];

export default taxSchemeRoutes;
